import { render, staticRenderFns } from "./trainingCourse.vue?vue&type=template&id=b346aa00&scoped=true&"
import script from "./trainingCourse.vue?vue&type=script&lang=js&"
export * from "./trainingCourse.vue?vue&type=script&lang=js&"
import style0 from "./trainingCourse.vue?vue&type=style&index=0&id=b346aa00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b346aa00",
  null
  
)

export default component.exports